<template>
  <!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：产品标签-修改
    -->
  <el-dialog title="修改标签" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" :model="form" :rules="formRules" ref="form">
      <el-form-item label="标签名称" prop="name" :label-width="formLabelWidth">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="标签排序" prop="sort" :label-width="formLabelWidth">
        <el-input v-model.number="form.sort" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addUser" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import PorductApi from '@/api/product.js';
  export default {
    components: {
      
    },
    data() {
      return {
        form: {
          kmd_label_id: 0,
          name: '',
          sort: ''
        },
        file_path: '',
        formRules: {
          name: [{
            required: true,
            message: '请输入标签名称',
            trigger: 'blur'
          }],
          sort: [{
            required: true,
            message: '标签排序不能为空'
          }, {
            type: 'number',
            message: '标签排序必须为数字'
          }]
        },
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        loading: false,
        /*是否上传图片*/
        isupload: false,
      };
    },
    props: ['open_edit', 'editform','type'],
    created() {
      this.dialogVisible = this.open_edit;
      this.form.kmd_label_id = this.editform.model.kmd_label_id;
      this.form.name = this.editform.model.name;
      this.form.sort = this.editform.model.sort;
      this.form.type = this.type;
    },
    methods: {
      /*修改用户*/
      addUser() {
        let self = this;
        let params = self.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            PorductApi.labelEdit(params, true).then(data => {
              self.loading = false;
              self.$message({
                message: '修改成功',
                type: 'success'
              });
              self.dialogFormVisible(true);
            }).catch(error => {
              self.loading = false;
            });
          }
        });
      },
      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },

    }
  };
</script>

<style>
  .img {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/label/Edit.vue